export function stripHtmlTags(input?: string) {
  return input
    ? input
        .replace(/<\/[^>]+>/g, ' ')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
    : '';
}
